<template>
    <div class="graph">
        <graph-legend :datasets="datasets" v-model="enabledDatasets" :dropdown="dropdown"
                      @add="onDatasetAdd" @remove="onDatasetRemove"/>
        <div :class="{graph__responsive: responsive}">
            <div :class="{graph__graph: responsive}">
                <slot :datasets="enabledDatasets" class="graph__graph">
                    No graph specified
                </slot>
            </div>

            <slot name="notification" :notification="notification" v-if="notification">
                <div class="graph__notification">
                    <div class="graph__notification__block">{{notification}}</div>
                </div>
            </slot>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import GraphLegend from './GraphLegend';

    @Component({
        components: {GraphLegend}
    })
    export default class GraphContainer extends Vue {
        @Prop({type: [String, Object]})
        graphComponent;
        @Prop({type: Array, required: true})
        datasets;
        @Prop({type: Array, required: false})
        labels;
        @Prop({type: Number, default: 3})
        dropdownLimit;
        @Prop({type: Number, default: 8})
        dropdownThreshold;
        @Prop({
            type: [Array, Function],
            default: () => ([
                '#18bf5C', '#ee411a', '#FF9900', '#14a3da', '#990099',
                '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E',
                '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC',
                '#E67300', '#8B0707', '#329262', '#5574A6', '#651067',
            ])
        })
        colors;
        @Prop({type: Boolean, default: false})
        responsive;
        enabledDatasets = [];

        get dropdown() {
            if (!this.datasets || this.datasets.length <= this.dropdownThreshold) {
                return null;
            }
            return {
                placeholder: this.$t('graph_container.label_dropdown'),
                limit: this.dropdownLimit,
                limit_warning: this.$t('graph_container.label_dropdown_limit', {limit: this.dropdownLimit}),
            };
        }

        get notification() {
            if (!this.datasets || !this.datasets.length) {
                return this.$t('graph_container.label_no_data');
            }
            if (!this.enabledDatasets || !this.enabledDatasets.some(dataset => !dataset.hidden)) {
                return this.$t('graph_container.label_no_selection');
            }
        }

        onDatasetAdd(dataset) {
            dataset.enabled = true;
            this.enabledDatasets.forEach((dataset, index) => {
                const colors = this.getLineColors(index);
                dataset.borderColor = colors.border;
                dataset.backgroundColor = colors.background;
                dataset.pointBackgroundColor = colors.point;
            });
        }

        onDatasetRemove(dataset) {
            dataset.enabled = false;
            this.enabledDatasets.forEach((dataset, index) => {
                const colors = this.getLineColors(index);
                dataset.borderColor = colors.border;
                dataset.backgroundColor = colors.background;
                dataset.pointBackgroundColor = colors.point;
            });
        }

        getLineColors(index) {
            // Converts the colors property to an object containing the colors for the line.
            let result;
            if (typeof(this.colors) === 'function') {
                result = this.colors(index);
            } else {
                result = this.colors[index];
            }
            if (typeof(result) === 'object') {
                return result;
            } else {
                return {
                    border: result,
                    background: result,
                    point: result,
                };
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/graphs/GraphContainer.vue